import { Translation, useTranslation } from '@morningtrain/react-translations'
import { ResourceSelector } from '@morningtrain/react-fields'
import React from 'react'

export default function AvailableScheduleUsers (props) {
  const defaultGroupKey = useTranslation('generic.unknown')
  const placeholderLabel = useTranslation('actions.select_employee')

  return (
    <ResourceSelector
      name='user_id'
      optionsKey='name'
      groupOptionsBy='employment_name'
      defaultGroupKey={defaultGroupKey}
      placeholder={placeholderLabel}
      label='Medarbejder'
      resourceName='shifts.schedule'
      operationName='available_users'
    >
      {props.children}
    </ResourceSelector>
  )
}
